"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  mutation deleteStoryboard($storyboardId: String!) {\n    deleteStoryboard(storyboardId: $storyboardId)\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var deleteStoryboardQuery = (0, _graphqlTag.default)(_templateObject());

var deleteStoryboard = function deleteStoryboard() {
  return {
    mutation: deleteStoryboardQuery,
    module: 'storyboards',
    buildVariables: function buildVariables(storyboardId) {
      return {
        storyboardId: storyboardId
      };
    }
  };
};

var _default = deleteStoryboard;
exports.default = _default;